import { Routes } from '@angular/router';
import { Home } from './pages/home/home';
import { Organizer } from './pages/organizer/organizer';
import { Lite } from './pages/lite/lite';
import { NotFound } from './pages/not-found/not-found';

export const routes: Routes = [
  {
    path: '',
    component: Home,
  },
  {
    path: 'organizer',
    component: Organizer,
  },
  {
    path: 'lite',
    component: Lite,
  },
  {
    path: '**',
    component: NotFound,
  },
];
